import React from 'react';
import { Link } from 'react-router-dom';
import { logoPng } from '../config/assets';
import './BrandFooter.css';

const base = process.env.PUBLIC_URL || '';

/**
 * @param {string} [linkColor] — цвет ссылок (темы гостевого меню)
 * @param {boolean} [dark] — тёмная полоса (KDS и т.п.)
 * @param {{ href: string, label: string }[]} [navItems] — ссылки (лендинг)
 */
export default function BrandFooter({ className = '', linkColor, dark = false, navItems }) {
  const hasNav = Array.isArray(navItems) && navItems.length > 0;
  const linkStyle = linkColor ? { color: linkColor } : undefined;

  const p = (base || '').replace(/\/$/, '');
  const demoStaticHref = `${p}/demo.html`.replace(/([^:]\/)\/+/g, '$1');

  const renderNavItem = (item) => {
    if (!item?.href) return null;
    const h = item.href;
    if (h.startsWith('http://') || h.startsWith('https://')) {
      return (
        <a
          key={`${h}-${item.label}`}
          className="brand-footer__nav-link"
          href={h}
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          {item.label}
        </a>
      );
    }
    if (h === '/demo.html' || h.startsWith('/demo.html?')) {
      const href = h.startsWith('/demo.html?')
        ? `${p}${h}`.replace(/([^:]\/)\/+/g, '$1')
        : demoStaticHref;
      return (
        <a
          key={href}
          className="brand-footer__nav-link"
          href={href}
          style={linkStyle}
        >
          {item.label}
        </a>
      );
    }
    return (
      <Link
        key={h}
        className="brand-footer__nav-link"
        to={h}
        style={linkStyle}
      >
        {item.label}
      </Link>
    );
  };

  return (
    <footer
      className={`brand-footer ${dark ? 'brand-footer--dark' : ''} ${className}`.trim()}
    >
      <div className="brand-footer__col">
        <div className="brand-footer__inner">
          <img
            className="brand-footer__img"
            src={logoPng()}
            alt=""
            width={36}
            height={36}
          />
          <a
            className="brand-footer__title"
            href="https://tez-hop.uz"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            tez-hop.uz
          </a>
        </div>

        {hasNav && (
          <nav className="brand-footer__nav" aria-label="Навигация">
            {navItems.map((item) => renderNavItem(item))}
          </nav>
        )}
      </div>
    </footer>
  );
}
